import { defineMessages } from 'react-intl';

export default defineMessages({
  editSettings: {
    description: 'ShipStations specific Carriers modal header label',
    defaultMessage: 'Edit ShipStation Settings',
    id: 'Mbd1iN',
  },
  shipstationAccount: {
    description: 'ShipStations specific Carriers modal sub-header label',
    defaultMessage: 'ShipStation Account',
    id: '4f8QkW',
  },
  accountNickname: {
    description: 'ShipStations specific Carriers modal nickname label',
    defaultMessage: 'Account Nickname',
    id: 'wrI2JP',
  },
  primaryAccount: {
    description: 'ShipStations specific Carriers modal primary account label',
    defaultMessage: 'Primary {name} account for automation',
    id: '0IC6Qy',
  },
  cancel: {
    description: 'Close ShipStations specific Carriers modal ',
    defaultMessage: 'Cancel',
    id: 'CMo1WE',
  },
  save: {
    description: 'Save ShipStations specific Carriers modal',
    defaultMessage: 'Save',
    id: '2eMRaL',
  },
  savingError: {
    description: 'Save ShipStations specific Carriers modal save error',
    defaultMessage: 'Unexpected error saving provider settings',
    id: '2R0sIQ',
  },
});
